<template>
    <FormLayout>
        <FormLayoutRow>
            <div class="d-md-flex flex-fill align-items-sm-center w-md-50">
                <FormLayoutLabel>{{ $tm('racecontestantdetails.relayteamname') }}</FormLayoutLabel>

                <div class="d-flex flex-fill">
                    <InputText
                        class="flex-fill"
                        v-model="value.RelayTeamName"
                        :validator="new ValidatorDef({ Required: true, Max: null, Min: null })"
                    />
                </div>
            </div>
            <div class="d-md-flex flex-fill align-items-sm-center w-md-50">
                <FormLayoutLabel>{{ $tm('racecontestantdetails.relayteamnationality') }}</FormLayoutLabel>

                <SelectCountry v-model="value.RealTeamNationalityID" />
            </div>
        </FormLayoutRow>
    </FormLayout>
</template>

<script setup lang="ts">
import { InputText, SelectCountry } from '@/components';
import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import { $tm } from '@/locize';
import { RaceContestantDetails } from '@/objects/generated';
import { ValidatorDef } from '@/objects/gui';

// The value of the model
const value = defineModel<RaceContestantDetails>({ required: true });
</script>
